module.exports = "<div role=\"tabpanel\" class=\"tab-pane\" v-bind:class=\"{hide:!show}\" v-show=\"show\" :transition=\"transition\" _v-0c89e409=\"\">\n    <slot _v-0c89e409=\"\"></slot>\n  </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-0c89e409&file=Tab.vue!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Tab.vue
 ** module id = 153
 ** module chunks = 0
 **/